export default "__VITE_ASSET__BKvO2JCi__"